export enum FEATURE_SWITCH_NAMES {
    LIVE_SESSION_BAR = 'liveSessionBar',
    MATERIAL_CHECK_FORM = 'materialCheckForm',
    SEARCH_SUGGEST = 'searchSuggest'
}
